
import {defineComponent, PropType} from "vue";
import InputImage from "@/components/UI/InputImage.vue";
import {CategoryImageRestDtoModel} from "@/models/api/pharma-cpc-product-category-mgmt/CategoryImageRestDtoModel";
import {ImageRestDto} from "@/components/layouts/catalog/categories/ImageRestDto";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";
import {FormMixin} from "@/components/base/FormMixin";
import {UIStateDto} from "@/dtos/UIStateDto";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";

export default defineComponent({
  name: "CategoryImageEditor",
  mixins: [FormMixin],
  components: {BaseDeleteButton, InputImage},
  props: {
    modelValue: {
      type: Object as PropType<ImageRestDto>,
      required: true,
    },
    docType: {type: String, required: true},
    title: {type: String, default: "customerImage"},
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      localDocumentKey: this.modelValue.image_document_key,
      localImage: this.modelValue.image,
      localSvg: this.modelValue.svg,
    };
  },
  watch: {
    modelValue: function (newVal: ImageRestDto) {
      console.log('CategoryImageEditor, new modelValue received');
      this.localDocumentKey = newVal.image_document_key;
      this.localImage = newVal.image;
      this.localSvg = newVal.svg;
    },
  },
  computed: {
    DpModuleEnum() {
      return DpModuleEnum;
    },
    hasSVG(): boolean {
      return !!this.localSvg && this.localSvg.length > 0;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit("update:modelValue", {
        image_document_key: this.localDocumentKey,
        image: this.localImage,
        svg: this.localSvg,
      });
      this.$emit("change");
    },
    onSvgChanged() {
      if (this.hasSVG) {
        this.localDocumentKey = null;
        this.localImage = null;
      }
      this.emitUpdate();
    },
    async clearSVG(): Promise<void> {
      await this.performGenericDelete(this.doClearSVG, this.doNothing, this.pageUI as UIStateDto, false);
    },
    async doClearSVG(): Promise<void> {
      this.localSvg = null;
      this.emitUpdate();
    },
    imageCleared() {
      this.localDocumentKey = null;
      this.localImage = null;
      this.emitUpdate();
    },
    documentKeyChanged(docKey: string | null) {
      this.localDocumentKey = docKey;
      this.localSvg = null;
      this.emitUpdate();
    },
    previewUrlChanged(url: string | null) {
      if (url) {
        this.localImage = CategoryImageRestDtoModel.createWithDefaults();
        this.localImage.image_url = url;
      } else {
        this.localImage = null;
      }
      this.emitUpdate();
    }
  },
});
